export default __webpack_public_path__ + "static/media/a8be24f4545080a3c281e632665754a11578323783723.b1c31eb8.webp";